import { createContext, useContext } from 'react';

interface RadioContextProps {
  value: any;
  select: (value: any) => void;
}

export const RadioContext = createContext<RadioContextProps>({} as any);
export const useRadioContext = () => useContext(RadioContext);
